import type {MaterialStoragesHistory} from '@domain/material-storage'
import {
  MaterialType,
  Status,
  useMaterialStorageHistory,
  getStoragesFromHistory,
  isHistoryStorageWithMaterialGuard
} from '@domain/material-storage'
import {useUpmPlantContext} from '@hconnect/upm'
import {Moment} from 'moment-timezone'

import type {Timeframe} from '../'

interface SelectorParams {
  storageHistory: MaterialStoragesHistory
  date: Moment
  hideDeleted: boolean
}

const selector = ({storageHistory, date, hideDeleted}: SelectorParams) => {
  const storagesFromHistory = getStoragesFromHistory(storageHistory, date)
  const storagesTypesWithMaterial = storagesFromHistory
    .filter(isHistoryStorageWithMaterialGuard)
    .filter((storage) => (hideDeleted ? storage.status !== Status.Deleted : true))
    .map((storage) => storage.materialType)

  return [...new Set(storagesTypesWithMaterial)]
}

interface StoredMaterialIdsQueryParams {
  materialType?: MaterialType
  timeFrame: Timeframe
  date?: Moment
  hideDeleted?: boolean
}

export const useStoredMaterialTypesFromHistoryQuery = ({
  timeFrame: [from, to],
  date,
  hideDeleted = true
}: StoredMaterialIdsQueryParams) => {
  const {plantId: plantCode} = useUpmPlantContext()
  return useMaterialStorageHistory({
    plantId: plantCode,
    from: from.toISOString(),
    to: to.toISOString(),
    options: {
      select: (data) => selector({storageHistory: data, date: date ?? to, hideDeleted}),
      throwOnError: true
    }
  })
}
